import { useTranslation } from 'react-i18next'

import ChannelInstore from './channel-instore'
import ChannelOmni from './channel-omni'
import ChannelOutstore from './channel-outstore'
import type { Instore, Outstore } from '../../../../../core/api/trajectory-photo/useApiGetStoreForecast'
import { useContext } from 'react'
import { StoreTrajectoryContext } from '../../state/store-trajectory-context'

interface ChannelsProps {
  instore: Instore
  outstore: Outstore
}

const Channels = ({ instore, outstore }: ChannelsProps) => {
  const { t } = useTranslation()
  const { referenceYear } = useContext(StoreTrajectoryContext)

  return (
    <div className="mg-store-trajectory-edit-channels">
      <div className="mg-store-trajectory-edit-channels-header">
        <div
          data-testid="mg-store-trajectory-edit-channels-header-title"
          className="mg-store-trajectory-edit-channels-header-title vp-subtitle-l"
        >
          {t('general.trajectory.store.edit.channels.title')}
        </div>
        <div
          data-testid="mg-store-trajectory-edit-channels-header-subtitle"
          className="mg-store-trajectory-edit-channels-header-subtitle vp-body-m"
        >
          {t('general.trajectory.store.edit.channels.subtitle', { referenceYear })}
        </div>
      </div>

      <div className="mg-store-trajectory-edit-channels-body">
        <div className="mg-store-trajectory-edit-channels-body-content">
          <ChannelOmni instore={instore} outstore={outstore} />

          <ChannelInstore instore={instore} />

          <ChannelOutstore outstore={outstore} />
        </div>
      </div>
    </div>
  )
}

export default Channels
